import { useRef } from 'react';
import { createPopper } from '@popperjs/core';

var usePopper = function () {
    var _popper = useRef();
    var el = useRef();
    var initPopper = function (reference, popper, options) {
        _popper.current = createPopper(reference, popper, options);
        el.current = popper;
    };
    var destroyPopper = function () {
        var popperInstance = _popper.current;
        if (popperInstance && el.current) {
            popperInstance.destroy();
        }
        _popper.current = undefined;
    };
    var updatePopper = function (options) {
        var popperInstance = _popper.current;
        if (popperInstance && options) {
            popperInstance.setOptions(options);
        }
        if (popperInstance) {
            popperInstance.update();
        }
    };
    return {
        popper: _popper.current,
        initPopper: initPopper,
        destroyPopper: destroyPopper,
        updatePopper: updatePopper,
    };
};

export { usePopper };
//# sourceMappingURL=usePopper.js.map
